module.exports = __webpack_public_path__ + "img/not.70a3b96a.png";